import * as Popover from '@radix-ui/react-popover';

import { useState } from 'react';

import { Toggle } from '@/components/ui/toggle';

import { cn } from '@/utils/styles';

import { LinkEditorPanel } from './link-editor-panel';

export type EditLinkPopoverProps = {
	onSetLink: (link: string, openInNewTab?: boolean) => void;
	initialUrl: string;
	isPressed: boolean;
};

export const EditLinkPopover = ({ onSetLink, initialUrl, isPressed }: EditLinkPopoverProps) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<Popover.Root
			open={isOpen}
			onOpenChange={setIsOpen}
		>
			<Popover.Trigger asChild>
				<Toggle
					size="sm"
					pressed={isPressed}
					className={cn(
						'hover:bg-accent data-[state=on]:bg-accent',
						'transition-colors',
						'text-accent-foreground data-[state=on]:text-accent-foreground'
					)}
					data-state={isPressed ? 'on' : 'off'}
				>
					<div
						title="Set Link"
						className="flex items-center justify-center text-primary"
					>
						<svg
							width="16px"
							height="16px"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</div>
				</Toggle>
			</Popover.Trigger>
			<Popover.Content
				side="top"
				align="start"
				sideOffset={10}
				collisionPadding={16}
				className="z-50"
			>
				<LinkEditorPanel
					onSetLink={onSetLink}
					initialUrl={initialUrl}
					allowEmpty
					onClose={() => setIsOpen(false)}
				/>
			</Popover.Content>
		</Popover.Root>
	);
};
